var React = require('react');

function ServiceHours (props) {
    return React.createElement("svg",props,[React.createElement("path",{"opacity":".5","d":"M16.25 13.61c.02-.16.03-.32.03-.5s-.02-.34-.03-.5l1.08-.85c.1-.07.12-.21.06-.33l-1.02-1.77a.26.26 0 0 0-.32-.12l-1.27.52c-.27-.2-.56-.38-.87-.5l-.2-1.37a.25.25 0 0 0-.25-.21h-2.05c-.13 0-.24.09-.25.21l-.2 1.36c-.31.13-.6.3-.86.5l-1.29-.5a.25.25 0 0 0-.31.1l-1.03 1.78a.25.25 0 0 0 .07.33l1.08.85a3.8 3.8 0 0 0 0 1l-1.08.85a.26.26 0 0 0-.07.32l1.03 1.78c.06.11.2.15.31.11l1.28-.51c.27.2.56.37.87.5l.2 1.36c.01.12.12.22.25.22h2.05c.13 0 .24-.1.25-.22l.2-1.36c.3-.13.6-.3.86-.5l1.28.51c.12.05.25 0 .31-.11l1.03-1.78a.25.25 0 0 0-.06-.32l-1.08-.85zm-3.82 1.3a1.8 1.8 0 1 1 0-3.6 1.8 1.8 0 0 1 0 3.6z","key":0}),React.createElement("path",{"d":"M22.8 5.56l-4.77-4-1.34 1.58 4.78 4zM8.16 3.14L6.83 1.55l-4.77 4L3.4 7.13zM12.43 3.77a9.34 9.34 0 1 0 0 18.68 9.34 9.34 0 0 0 0-18.68zm0 16.6a7.26 7.26 0 1 1 0-14.51 7.26 7.26 0 0 1 0 14.51z","key":1})]);
}

ServiceHours.displayName = "ServiceHours";

ServiceHours.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = ServiceHours;

ServiceHours.default = ServiceHours;



//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ServiceHours.svg
// module id = 651
// module chunks = 168707334958949